module.exports = __webpack_public_path__ + "static/img/logo.0b3161f3.jpg";